import script from "./userAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./userAgreement.vue?vue&type=script&setup=true&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=0d23f519&scoped=true&lang=css"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d23f519"]])

export default __exports__